export default __webpack_public_path__ + "static/GT-Walsheim-Pro-Bold-b12cee50802fdbf68a77eb6e8cc53501.ttf";